/**
 * GCP Vertex AI 에서 모델이 호스팅되는 알려진 region 목록.
 *
 * Location 입력 <datalist> 의 자동완성 후보로만 사용 — 자유 입력은 그대로 허용하므로
 * 목록에 없는 신규 region 도 직접 입력 가능(목록 stale 대비). 실제 가용성은 연결 테스트로 검증.
 */
export const VERTEX_REGIONS = [
  // 멀티리전
  'global',
  'us',
  'europe',
  // 북미
  'us-central1',
  'us-east1',
  'us-east4',
  'us-east5',
  'us-west1',
  'us-west4',
  'northamerica-northeast1',
  // 유럽
  'europe-west1',
  'europe-west2',
  'europe-west3',
  'europe-west4',
  'europe-west9',
  // 아시아·태평양
  'asia-northeast1',
  'asia-northeast3',
  'asia-south1',
  'asia-southeast1',
  'australia-southeast1',
] as const;
